import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'onlynewusermodal.title',
    defaultMessage: 'This offer is only available to new patients',
  },
  description: {
    id: 'onlynewusermodal.description',
    defaultMessage: 'Please contact us if you have any questions',
  },
  link: {
    id: 'onlynewusermodal.link',
    defaultMessage: 'Questions? Contact us →',
  },
})
